import { TooltipArrow, TooltipContent } from '@radix-ui/react-tooltip';
import styled from 'styled-components';

export const StyledTooltipContent = styled(TooltipContent)`
  display: flex;
  gap: 0.3rem;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: ${({ theme }) => theme.radius.small};
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  opacity: 1;
  z-index: 20;
  padding: 1.2rem;
`;

export const StyledTooltipArrow = styled(TooltipArrow)`
  fill: ${({ theme }) => theme.colors.background.tertiary};
`;

export const StyledTooltipText = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  line-height: 1.5rem;
  color: ${({ theme }) => theme.colors.black};
`;
